import { ref, remove } from 'firebase/database';
import { hashString } from '../../Helpers/hashString';
import { SessionWithId } from '../../Models/session';
import { auth, database } from '../firebase';
import { getSession } from './GetSession';

export const LogOutOfSession: (
    session: SessionWithId,
) => Promise<void> = async (session) => {
    try {
        let currentSession = await getSession(session);

        if (!currentSession?.session.people) {
            return;
        }

        if (!auth.currentUser) {
            throw Error('You are not logged in');
        }

        const currentUserHash = hashString(auth.currentUser.email!);

        await remove(
            ref(database, `sessions/${session.id}/people/${currentUserHash}`),
        );
    } catch (error) {
        throw error;
    }

    return;
};
